import React from 'react';
import './Privacypolicy.css'

const PrivacyPolicy = () => {
    return (
        <section className="privacySection">   
           <div className=" pb-5 col-md-5 col-sm-10 col-11 col-lg-6 offset-1">
           <h3 className="pb-3 pt-5 text-center ">Privacy Policy</h3>
            <p>Our company pays special attention to privacy of your data. No information from your gadget will be transferred to a third party. We respect our customers.</p>
           </div>
        </section>
    );
};

export default PrivacyPolicy;